import SaleLotsTable from "./SaleLotsTable";

export default SaleLotsTable;
